export default {
  methods: {
    getLeadStatusValueByName (type) {
      switch (type.toUpperCase()) {
        case "LEAD":
          return 1;
        case "DONOR":
          return 2;
        case "RECURRENT":
          return 3;
        default:
          return 1;
      }
    },
    getInitials(firstName = "", lastName = "", email = "") {
      if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`;
      }

      if (firstName) {
        return firstName[0];
      }

      return email[0] || "";
    },
    getStatus(status = "") {
      if (typeof status !== "string") {
        return {
          text: this.$t(`members.status.lead`),
          description: this.$t(`members.status_description.lead`),
          icon: "perm_identity",
          color: "orange"
        };
      }
      switch (status.toUpperCase()) {
        case "LEAD":
          return {
            text: this.$t("leads.statuses.lead"),
            icon: "perm_identity",
            color: "orange",
            textColor: "orange--text"
          };
        case "DONOR":
          return {
            text: this.$t("leads.statuses.donnor"),
            icon: "schedule",
            color: "yellow accent-4",
            textColor: "yellow--text text--accent-4"
          };
        case "RECURRENT":
          return {
            text: this.$t("leads.statuses.recurrent"),
            icon: "cached",
            color: "green accent-2",
            textColor: "green--text text--accent-2"
          };
        default:
          return {
            text: this.$t("leads.statuses.lead"),
            icon: "perm_identity",
            color: "orange",
            textColor: "orange--text"
          };
      }
    },
    getColorTypeStatusEmail(status) {
      switch (status) {
        case "OPT_OUT":
          return "gray";
        case "HARD_BOUNCE":
          return "error";
        case "SOFT_BOUNCE":
          return "yellow";
        case "VERIFIED":
          return "success";
        default:
          return "gray";
      }
    },
    getIconTypeStatusEmail(status) {
      switch (status) {
        case "OPT_OUT":
          return "person_remove";
        case "HARD_BOUNCE":
        case "SOFT_BOUNCE":
          return "trending_up";
        case "VERIFIED":
          return "verified";
        default:
          return "remove_circle";
      }
    },
    getTextStatusEmail(status) {
      switch (status) {
        case "OPT_OUT":
          return "OPT-OUT";
        case "HARD_BOUNCE":
          return "HARD-BOUNCE";
        case "SOFT_BOUNCE":
          return "SOFT-BOUNCE";
        case "VERIFIED":
          return "VERIFIED";
        default:
          return "UNVERIFIED";
      }
    }
  }
};
